import { FC } from 'react';
import { Form, Table, Typography } from 'antd';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { OfficeObservationInventory } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';

type VisitReporInventoryItem = OfficeObservationInventory<'payload'> &
	Pick<OfficeObservationInventory, 'type'>;

type VisitReporInventoryForm = {
	lists: VisitReporInventoryItem[];
};

const FBDHVisitReportInventory: FC = () => {
	const { officeObservation } = useFBDHVisitReportApprovalPage();
	const { warehouse } = officeObservation ?? {};
	const { form, fieldName } = useForm<VisitReporInventoryForm>();

	return (
		<Form.Provider>
			<Typography.Title level={3}>Kondisi Barang Persediaan</Typography.Title>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists:
							warehouse?.inventories?.map((record) => {
								return {
									...record,
									typeId: record.type.id,
								};
							}) ?? [],
					} as VisitReporInventoryForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as VisitReporInventoryForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'No',
										render: (_, __, index) => index + 1,
										width: 1,
										align: 'center',
									},
									{
										title: 'Jenis Barang Persediaan',
										render: (_, record) => record.type.value ?? '-',
									},
									{
										title: 'Detail Barang Persediaan',
										render: (_, record) => record.name ?? '-',
									},
									{
										title: 'Jumlah Persediaan Saat Kunjungan Usaha',
										render: (_, record) => record.quantity ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
		</Form.Provider>
	);
};

export default FBDHVisitReportInventory;
